import appConfig from "../appconfig";
import ProductSelection from "../domains2/orders/ProductSelection";

export default {
	methods: {
		createComplexProductSelection(item) {
			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: appConfig.tenantConfig.productSelectionExpiration
				}
			};
			const productSelection = ProductSelection.createFromProduct(item, psOptions);
			ProductSelection.ChangeQuantity(productSelection, item, 1);
			const productGroup = this.productCatalog.getProduct(productSelection.productId).groups.find(g => g.appearance === "single");
			if (productGroup !== undefined && productGroup !== null) {
				const selectedProducts = productSelection.groups
					.find(g => g.groupId === productGroup.id).selectedProducts;
				const productId = selectedProducts[0];
				selectedProducts.splice(selectedProducts.indexOf(productId), 1);
				const product = this.productCatalog.getProduct(productId);
				selectedProducts.push({
					productId: product.id,
					groups: product.groups.map(g => {
						return {
							groupId: g.id,
							selectedProducts: []
						};
					}),
					configurations: [
						...product.configurations
							.filter(config => config.appearance === "checklist")
							.map(config => {
								const selectedValue = config.options.defaultSelectedArray ? config.options.defaultSelectedArray : [];
								return {
									configurationId: config.id,
									selectedValue: selectedValue
								};
							})]
				});
			}
			return productSelection;
		}
	}
};
